import React from 'react';
import Jobs from '../components/administration/jobs';
import { PageHead } from '../components/ui';

export default function AdministrationJobsPage() {
    return (
        <>
            <PageHead>
                <div>
                    <h2>Tâches planifiées</h2>
                    <p>État des collectes, lancement à la demande et activation des planifications.</p>
                </div>
            </PageHead>

            <Jobs />
        </>
    );
}
